<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t("g.create_at") }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('bill.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.Nickname"
            :placeholder="$t('bill.user_nickname')"></el-input>
        </div>
        <div class="item">
          <span class="label">手机号</span>
          <el-input class="inp" size="small" v-model="formData.Mobile" placeholder="请输入手机号码"></el-input>
        </div>
        <!-- <div class="item">
            <span class="label">{{ $t('g.operator') }}</span>
            <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valCode"
              :props="formData.props" :options="render.cascade_options_direct" />
          </div> -->
        <div class="item">
          <span class="label">用户ID</span>
          <el-input class="inp" size="small" v-model="formData.UserId" placeholder="请输入用户ID"></el-input>
        </div>
        <div class="item" v-if="formData.RechargeType == 0">
          <span class="label">充值代理ID</span>
          <el-input class="inp" size="small" v-model="formData.AdminId" placeholder="请输入天数充值代理账号ID"></el-input>
        </div>
        <div class="item" v-if="formData.RechargeType == 0">
          <span class="label">充值类型</span>
          <el-select class="inp" v-model="formData.recharge_type" size="small" placeholder="请选择充值类型">
            <el-option label="普通用户" :value="1"></el-option>
            <el-option label="代理商账户" :value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" :stripe="true" @row-click="func.showDetails" style="width: 100%">
        <el-table-column prop="Id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="Nickname" width="120" label="用户昵称">
        </el-table-column>
        <el-table-column prop="Mobile" width="120" label="手机号">
        </el-table-column>
        <el-table-column prop="RechargeType" width="120" label="充值类型">
          <template #default="scope">
            <span v-if="scope.row.RechargeType == 1">普通用户</span>
            <span v-else-if="scope.row.RechargeType == 2">代理商账户</span>
          </template>
        </el-table-column>
        <el-table-column prop="UserId" label="微信账号ID" width="120">
        </el-table-column>
        <el-table-column prop="AdminId" label="WEB账号ID" width="120">
        </el-table-column>
        <el-table-column prop="DaysNum" width="120" label="充值天数">
        </el-table-column>
        <el-table-column prop="Money" width="120" label="收取金额">
        </el-table-column>
        <el-table-column prop="RestDays" width="120" label="账户剩余天数">
        </el-table-column>
        <el-table-column prop="RefundDays" width="120" label="回收天数">
        </el-table-column>
        <el-table-column prop="RefundMoney" width="120" label="退款金额">
        </el-table-column>
        <el-table-column prop="DaysUnit" width="140" label="代理商购买单价">
        </el-table-column>
        <el-table-column prop="PayStatus" width="120" label="支付状态">
          <template #default="scope">
            <el-tag v-if="scope.row.PayStatus == 0">未支付</el-tag>
            <el-tag class="tag-success" v-else-if="scope.row.PayStatus == 1">已支付</el-tag>
            <el-tag class="tag-fail" v-else-if="scope.row.PayStatus == 2">已退款</el-tag>
            <el-tag class="tag-warning" v-else-if="scope.row.PayStatus == 3">退款中</el-tag>
            <el-tag class="tag-success" v-else-if="scope.row.PayStatus == 4">退款成功</el-tag>
            <el-tag class="tag-info" v-else-if="scope.row.PayStatus == 5">退款失败</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="RechargeType"  label="充值对象" width="140" v-if="formData.RechargeType == 0">
            <template #default="scope">
                <span>{{ scope.row.RechargeType == 1 ? '普通客户' : '代理商账户' }}</span>
            </template>
          </el-table-column> -->
        <el-table-column prop="ComboStartAt" min-width="180" label="此订单套餐开始时间">
        </el-table-column>
        <el-table-column prop="CreateAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column prop="AgentCode" v-if="!isOperator()" :label="$t('g.agent_code')" width="100">
        </el-table-column>
        <el-table-column prop="Remark" min-width="130" label="备注">
        </el-table-column>
        <el-table-column width="120" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button v-if="scope.row.RechargeType == 1"
              :class="scope.row.PayStatus == 0 || scope.row.PayStatus == 2 || scope.row.PayStatus == 3 || scope.row.PayStatus == 4 ? 'tag-info' : ''"
              :disabled="scope.row.PayStatus == 0 || scope.row.PayStatus == 2 || scope.row.PayStatus == 3 || scope.row.PayStatus == 4"
              @click="func.recycle(scope.row)" class="btn-edit" type="primary">回收天数</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="回收天数" v-model="formData.orderType" center align-center style="width:40%">
      <el-form label-width="120px">
        <el-form-item label="订单ID">
          <el-input v-model="formData.orderInfo.Id" disabled></el-input>
        </el-form-item>
        <el-form-item label="退回天数">
          <el-input v-model="formData.orderInfo.Days" disabled>
            <template #append>天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input v-model="formData.orderInfo.Money">
            <template #append>元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="default" @click="formData.orderType = false">{{ $t('g.btn_cancel') }}</el-button>
          <el-button type="primary" @click="func.orderSave()">{{ $t('g.btn_confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" align-center width="90%">
      <el-descriptions border column="3">
        <el-descriptions-item label="ID">{{ formData.curData.Id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.mobile')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.Mobile
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('bill.nickname')" v-if="!isOperator()">
          <el-link type="primary" @click="formData.userDrawerVisible = true">{{ formData.curData.Nickname
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="充值类型">
          <span v-if="formData.curData.RechargeType == 1">普通用户</span>
          <span v-else-if="formData.curData.RechargeType == 2">代理商账户</span>
        </el-descriptions-item>
        <el-descriptions-item label="微信账号ID">{{ formData.curData.UserId
        }}</el-descriptions-item>
        <el-descriptions-item label="WEB账号ID">{{ formData.curData.AdminId
        }}</el-descriptions-item>
        <el-descriptions-item label="充值天数">{{ formData.curData.DaysNum
        }}</el-descriptions-item>
        <el-descriptions-item label="收取金额">{{ formData.curData.Money
        }}</el-descriptions-item>
        <el-descriptions-item :label="'账户剩余天数(' + formData.curData.AdminName + ')'">{{
          formData.curData.RestDays }}</el-descriptions-item>
        <el-descriptions-item label="回收天数">{{ formData.curData.RefundDays
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{ formData.curData.RefundMoney
        }}</el-descriptions-item>
        <el-descriptions-item label="代理商购买单价">{{ formData.curData.DaysUnit
        }}</el-descriptions-item>
        <el-descriptions-item label="支付状态">
          <el-tag v-if="formData.curData.PayStatus == 0">未支付</el-tag>
          <el-tag class="tag-success" v-else-if="formData.curData.PayStatus == 1">已支付</el-tag>
          <el-tag class="tag-fail" v-else-if="formData.curData.PayStatus == 2">已退款</el-tag>
          <el-tag class="tag-warning" v-else-if="formData.curData.PayStatus == 3">退款中</el-tag>
          <el-tag class="tag-success" v-else-if="formData.curData.PayStatus == 4">退款成功</el-tag>
          <el-tag class="tag-info" v-else-if="formData.curData.PayStatus == 5">退款失败</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="此订单套餐开始时间">{{ formData.curData.ComboStartAt
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreateAtStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ formData.curData.Remark
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-drawer v-model="formData.userDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <MemberList :propId="formData.curData.UserId"></MemberList>
    </el-drawer>
  </div>
</template>

<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { shortcuts, operators, operatorList, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import axios from "axios"
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import cfg from '@/common/conf'
import { user, isOperator } from '@/data/token'
import i18n from '@/data/i18n/index'
import MemberList from '@/views/member/list.vue'
export default {
  name: 'BillRefundRecord',
  components: {
    MemberList
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const render = {
      devTypes: [
        {
          label: t("device.types.ebox"),
          value: 1
        },
        {
          label: t("device.types.cbox"),
          value: 2
        },
        {
          label: t("device.types.pile"),
          value: 3
        },
      ],
      operators,
      operatorList,
      shortcuts,
      cascade_options_direct
    }
    const formData = reactive({
      curData: {},
      AdminId: '',
      UserId: '',
      tableData,
      valAddDevType: 1,
      orderType: false,
      valTime: '',
      valDevNo: "",
      valOrderSn: "",
      curPage: 1,
      pageSize: 10,
      total: 0,
      valName: '',
      valCode: 0,
      dialogVisible: false,
      userDrawerVisible: false,
      orderInfo: {
        Id: '',
        RestDays: '',
        Money: ''
      },
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: true
      },
      RechargeType: 0
    })
    const func = {
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      async recycle(row) {
        formData.orderType = true
        formData.orderInfo.Id = row.Id

        let timestamp = Math.floor(new Date().getTime() / 1000)
        let timestamp2 = Math.floor(new Date(row.ComboStartAt).getTime() / 1000)
        if (row.ComboStartAt && timestamp < timestamp2) {
          formData.orderInfo.Days = row.DaysNum;
        } else {
          let day = Math.ceil((timestamp - timestamp2) / 86400);
          if (day >= row.DaysNum) {
            formData.orderInfo.Days = 0;
          } else {
            formData.orderInfo.Days = row.DaysNum - day;
          }
        }
      },
      async orderSave() {
        let params = {
          Id: formData.orderInfo.Id,
          Money: formData.orderInfo.Money
        }
        try {
          let res = await axios.post(`/admin/agencyRecharge/refund`, params)
          if (res) {
            ElMessage.success('回收成功')
            formData.orderType = false
            func.loadData()
          }
        } catch (e) {
          console.log('orderSave', e)
        }
      },
      async showDetails(row, column) {
        console.log('row', row)
        if (column && column.label == t('g.operation')) {
          return;
        }
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.AdminId) {
            params.AdminId = formData.AdminId
          }
          if (formData.UserId) {
            params.UserId = formData.UserId
          }
          if (formData.Nickname) {
            params.Nickname = formData.Nickname
          }
          if (formData.recharge_type) {
            params.RechargeType = formData.recharge_type
          }
          if (formData.Mobile) {
            params.Mobile = formData.Mobile
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          let res = await axios.get(`/admin/agencyRecharge/get`, {
            params
          })
          console.log('数据111', res)
          formData.total = res.Total
          res.List.map((item) => {
            item.CreateAtStr = toDay(item.CreateAt)
            if (item.ComboStartAt) {
              item.ComboStartAt = toDay(item.ComboStartAt)
            } else {
              item.ComboStartAt = '--'
            }
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      func.loadData()
      if (localStorage.getItem('user_info')) {
        let user_info = JSON.parse(localStorage.getItem('user_info'))
        formData.RechargeType = user_info.IsRecharge
      }
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  .table-detail {
    display: flex;
    flex-direction: column;
    margin-right: 9.375rem;
    padding-left: 4rem;
    padding-top: 1rem;

    .orders {
      .order {
        display: flex;
        margin-bottom: 0.5rem;
        align-items: center;

        >div {
          margin-right: 1rem;
        }
      }
    }

    >.item {
      margin-right: 0.625rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.625rem;
      color: #333333;

      >img {
        margin-left: 0.625rem;
        width: 4rem;
        height: 3rem;
        object-fit: cover;
      }
    }
  }

  .boximg {
    width: 4rem;
    height: 3rem;
    object-fit: cover;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;

        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 88%;
      margin: 0 auto;
    }

    &.line-3 {
      :deep(.el-form-item) {
        width: 33%;
      }
    }

    .inp {
      width: 100%;
    }

    .avatar-uploader {
      :deep(.el-upload) {
        border: 1px dashed #d9d9d9;
        border-radius: 0.375rem;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409eff;
        }
      }
    }

    .avatar-uploader-icon {
      font-size: 1.75rem;
      color: #8c939d;
      width: 11rem;
      height: 9rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .avatar {
      width: 11rem;
      height: 9rem;
      display: block;
      object-fit: cover;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }
}
</style>